// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".kuboard-header .el-progress__text{display:none}.kuboard-header .el-progress{line-height:2px;height:2px}.kuboard-header .el-progress .el-progress-bar{top:0;position:fixed;left:0;right:0;margin-right:0;padding-right:0}", ""]);
// Exports
module.exports = exports;
